module.exports = __webpack_public_path__ + "static/wrkat-hero@2x-min-fe9adfb5a68f5e1c2a5dc4f1ab31500e.jpg";